/**
 * The vendor: a counter with a cage over it and the shelves behind.
 *
 * Beside the stash for the reason the stash is beside it, and caged because everything on those
 * shelves belongs to somebody who is not the player.
 *
 * Inert. What can be bought and sold is #209's, and this is furniture until it lands.
 */

import { stationPart } from '@/modes/hub/sim/stations/stationParts';
import type { HubStation } from '@/modes/hub/sim/stations/hubStationContract';
import type { StationFrame } from '@/modes/hub/sim/stations/stationParts';
import { vec3 } from '@/sim/vec3';

const FRAME: StationFrame = {
  kindId: 'vendor',
  position: vec3(-11, 0, 4),
  yawDegrees: -90,
};

export const VENDOR_STATION: HubStation = {
  ...FRAME,
  colliders: [
    stationPart(FRAME, 'counter', vec3(0, 0.55, -0.5), vec3(1.7, 0.55, 0.35), 'roughTimber'),
    // The cage runs from the counter top to head height, so the gap is a hatch rather than a hole.
    stationPart(FRAME, 'cage', vec3(0, 1.65, -0.5), vec3(1.7, 0.55, 0.06), 'rustedSteel'),
    stationPart(FRAME, 'shelves', vec3(0, 1.1, 0.25), vec3(1.7, 1.1, 0.3), 'roughTimber'),
  ],
};
